import { TransformedPaymentRecords } from '../../types'

const mergePaymentsWithPendingPayments = ({
  queryPaymentRecords,
  pendingPaymentRecords,
}: {
  queryPaymentRecords: TransformedPaymentRecords[]
  pendingPaymentRecords: TransformedPaymentRecords[]
}) => {
  return pendingPaymentRecords.reduce(
    (records: TransformedPaymentRecords[], curr: TransformedPaymentRecords) => {
      if (
        !queryPaymentRecords.find(
          (rec: TransformedPaymentRecords) =>
            rec.externalIdentifier === curr.externalIdentifier,
        )
      ) {
        return [...records, curr]
      }
      return records
    },
    queryPaymentRecords,
  )
}

export default mergePaymentsWithPendingPayments
